import {useEffect} from "react";

const APP_TITLE = "KAI";

/**
 * Sets document.title to `<name> - KAI` while a named topic is displayed, and
 * falls back to `KAI` whenever the name is absent (e.g. the leaf's own data is
 * still loading). Content routes that mount no leaf are handled by ContentPage,
 * which resets the title to `KAI` for its loader/status/error states and on
 * unmount.
 */
export function useContentTitle(name: string | undefined, enabled = true) {
    useEffect(() => {
        if (!enabled) return;
        document.title = name ? `${name} - ${APP_TITLE}` : APP_TITLE;
    }, [name, enabled]);
}
